
import Vue from 'vue';
import { VInput } from 'vuetify/lib';
import { Anuncio } from '@/models/Anuncio';
import { AnuncioDetalle } from '@/models/AnuncioDetalle';
import AnuncioService from '@/services/AnuncioService';
import MaterialService from '@/services/MaterialService';
import TipoAnuncioService from '@/services/TipoAnuncioService';
import RULES from '@/mixins/rules';
import EstablecimientoService from '@/services/EstablecimientoService';
import CustomFile from "@/components/Common/CustomFile.vue";
import CustomFileInputAnuncio from "@/components/Common/CustomFileAnuncio.vue";
import Direccion from "@/components/Beneficiarios/Direccion.vue";
import {Domicilio} from "@/models/Domicilio";
import EventBus from "@/plugins/event-bus";
import {VForm} from "@/types/formvalidate";


export default Vue.extend(
  {
    props: {
      documentoPropiedadProp: {
        type: Object,
        default: null
      },
      contratoArrendamientoProp: {
        type: Object,
        default: null
      },
      propiedadProp: {
        type: String,
        default: '0'
      },
      updateFile: {
        type: Boolean,
        default: false
      },
      value2: Object,
      idEstablecimiento: {
        type: Number,
        default: 0,
      },
      isNotSubmit: {
        type: Boolean,
        default:true
      },
      object: {
        type: Anuncio,
        default: new Anuncio()
      },
      estatus: {
        type: Number,
        default: 1
      },
      update: {
        type: Boolean,
        default: false
      },
    },
    mixins: [RULES],
    data: () => ({
      estatusPropiedad: [
        { value: 1, text: 'Propio' },
        { value: 2, text: 'Arrendado' },
      ],
      renovacionInterna: false,
      uploadPercentage: 0,
      defaultLatitud: 18.520326,
      defaultLongitud: -88.305718,
      menu: false,
      dialog: false,
      menu_fin: false,
      loading: false,
      editable: false,
      formData: new Anuncio(),
      riesgo: false,
      formDefault: new Anuncio(),
      disabled: false,
      fileInputRenovacion: null,
      disabledForm: {
        localidad: true,
        asentamiento: true,
      },
      materiales: [] as any[],
      tiposAnuncios: [] as any[],
      periodos: Array.from({ length: 3 }, (_, i) => (new Date().getFullYear() - i).toString()),
      documento: null,
      showFotografia: false,
      showMemoria: false,
      showResponsiva: false,
      dialogSendReview: false,
      selectedSolicitud: new Anuncio() as any,
      dialogPDF: false,
      usePiezaDia: false,
      usePiezaMes: false,
      usePieza: false,
      isMesDisabled: false,
      fileInputValue: null,
      fileInputValueIzquierda: null,
      fileInputValueDerecha: null,
      selectedOption: null,
      arrayAnuncios: [] as any[],
      propiedadLocal: 0,
    }),
    watch: {
      'formData.propiedad': {
        immediate: true,
        handler(d){
          //console.log("propiedad", this.formData.propiedad);
        }
      },
      object:{
        immediate: true,
        deep: true,
        handler(d){
          //console.log("object", this.object);
          this.formData = this.object;
          //console.log("this.formData.documento_propiedad_archivo", this.formData.documento_propiedad_archivo);
          this.formData.contrato_arrendamiento_archivo = this.contraroArrendamientoProp;
          //console.log("this.formData.propiedad", this.formData.propiedad);
          this.selectedSolicitud = this.object;
          if(this.estatus == 10 || this.estatus == 4) {
            this.disabled = true;
          }
          
          if (this.formData.is_mecanismo_electrico === 1) {
            //@ts-ignore
            this.selectedOption = true;
          } else if (this.formData.is_accion_viento === 1) {
            //@ts-ignore
            this.selectedOption = false;
          }
        }
      },
      /*'formData.tipo_anuncio_id': {
        immediate: true,
        handler(value) {
          const piezaDiaAnuncios = [7];
          const piezaMesAnuncios = [1];
          const piezaAnuncio = [4, 5, 8, 10]
          
          this.usePiezaDia = piezaDiaAnuncios.includes(value);
          this.usePiezaMes = piezaMesAnuncios.includes(value) && !piezaDiaAnuncios.includes(value);
          this.usePieza = piezaAnuncio.includes(value);

          //Validación renovación cuando sea tipo anuncio mantas y lonas y mes actual sea noviembre
          // cargar 12 meses por default
          if(value === 1){
            this.updateMesField();
          }

        }
      },*/
      /*'selectedOption': {
        handler(value) {
          if (value === true) {
            this.formData.is_mecanismo_electrico = true;
            this.formData.is_accion_viento = false;
          } else if (value === false) {
            this.formData.is_mecanismo_electrico = false;
            this.formData.is_accion_viento = true;
          }
        }
      },*/
      //Validación renovación cuando sea tipo anuncio mantas y lonas y mes actual sea noviembre
      // cargar 12 meses por default
      'formData.renovacion': {
        immediate: true,
        handler() {
          this.updateMesField();
          setTimeout(() => {
            this.renovacionInterna = this.formData.renovacion;
          }, 2000);
          
        }
      },
    },
    methods: {
      downloadFormatResponsiva() {
        //descargar formato responsiva ubicado en /pdf
        const rutaPDF = process.env.BASE_URL + "pdfs/responsiva_daños.docx";
        window.open(rutaPDF, "_blank");
      },
      changeEstatusPropiedad(value: any){
        this.propiedadLocal = value;
      },
      validacionRiesgo(){
        this.riesgo = false;
        //Recorrer el arreglo de anuncios para ver si hay algún tipo 10 o 2
        this.arrayAnuncios.forEach((anuncio: any) => {
          //console.log(anuncio);
          if(anuncio.tipo_anuncio_id == 10 || anuncio.tipo_anuncio_id == 2){
            this.riesgo = true;
          }
        })
      },
      validacionPieza(value: any){
        let response = false;
        const piezaAnuncio = [4, 5, 8, 10]
        response = piezaAnuncio.includes(value);
        return response;
      },
      validacionPiezaDia(value: any){ 
        let response = false;
        const piezaDiaAnuncios = [7];
        
        response = piezaDiaAnuncios.includes(value);

        return response;
      },
      validacionPiezaMes(value: any){ 
        let response = false;
        const piezaDiaAnuncios = [7];
        const piezaMesAnuncios = [1];
        
        response = piezaMesAnuncios.includes(value) && !piezaDiaAnuncios.includes(value);

        //Validación renovación cuando sea tipo anuncio mantas y lonas y mes actual sea noviembre
        // cargar 12 meses por default
        if(value === 1){
          const currentMonth = new Date().getMonth() + 1;
          const isRenovacionChecked = this.formData.renovacion;
          if (isRenovacionChecked && currentMonth === 11) {
            this.formData.mes = 12;
            this.isMesDisabled = true;
          } else {
            this.formData.mes = 0;
            this.isMesDisabled = this.disabled;
          }
          //this.updateMesField();
        }
        return response;
      },
      addAnuncio() {
        this.arrayAnuncios.push(new AnuncioDetalle());
      },
      deleteAnuncio(index: number, item: any) {
        //console.log(index, item);
        this.arrayAnuncios.splice(index, 1);
        if (item.id) {
          AnuncioService.deleteDetalle(item.id).then(() => {
            //console.log('Anuncio eliminado');
            this.$toast.success('Anuncio eliminado');
          })
        }
      },
      cancelarEnvio() {
        this.selectedSolicitud = null;
        this.dialogSendReview = false;
      },
      setDomicilio(domicilio: Domicilio) {
        this.formData.domicilio = Object.assign({}, domicilio);
      },
      async showFile(id: any){
        //@ts-ignore
        const response = await EstablecimientoService.descargarFormato(`documentacion/${id}`,{},'GET','Temp');

        let file = new Blob([response.data],{type: response.headers['content-type']});
        const url = window.URL.createObjectURL(file);                

        //@ts-ignore
        this.documento = {
            //@ts-ignore
            title: this.label,
            url: url,
            mime: response.headers['content-type'] 
        }
        this.dialog = true;
      },
      setFotografia(event: any, type: any) {
        const file = event.target ? event.target.files[0] : event;
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (file && !validTypes.includes(file.type)) {
          this.$toast.error('Para la fotografía solo se permiten archivos PNG, JPEG, JPG');
        } else {
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            var file = fileReader.result;
            this.formData[type] = file + "";
          });
          fileReader.readAsDataURL(file);
        }
      },
      validateFileRenovacion(event: any) {
        const file = event.target ? event.target.files[0] : event;
        if (file && file.type !== 'application/pdf') {
          this.$toast.error('Para el anterior permiso solo se permiten archivos PDF');
        } else {
          this.setAnteriorPermiso(file);
        }
      },
      setAnteriorPermiso(file: any) {
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          var file = fileReader.result;
          this.formData.anterior_permiso_anuncio = file + "";
        });
        fileReader.readAsDataURL(file);
      },
      clearFotografia() {
        //@ts-ignore
        //this.$refs.inputFoto.reset();
        this.formData.fotografia = null; // Esto debería borrar el archivo seleccionado
      },
      setMemoriaEstructural(e: any){
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          var file = fileReader.result;
          this.formData.espectacular = 1;
          this.formData.memoria_calculo_estructural = file + "";
        });
        fileReader.readAsDataURL(e);
      },
      setResponsivaTerceros(e: any){
        const fileReader = new FileReader()
        this.formData.espectacular = 1;
        fileReader.addEventListener('load', () => {
          var file = fileReader.result;
          this.formData.responsiva_terceros = file + "";
        });
        fileReader.readAsDataURL(e);
      },
      reset() {
        this.formData = Object.assign({}, this.formDefault);
        this.arrayAnuncios = [];
      },
      objectToFormData(obj: any, formData: any) {
        //console.log("obj", obj);
        formData.append(`documento[${obj.code}][file]`, obj.file);
        formData.append(`documento[${obj.code}][code]`, obj.code);

        return formData;
      },
      getBase64(file: any) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      },
      async handleFormSubmit() {
        this.formData.locacion_id = this.idEstablecimiento;
        EventBus.$emit("update-direccion");
        this.formData.arreglo_anuncios = this.arrayAnuncios;
        let fotografia_archivo = await this.getBase64(this.formData.documentos['fotografia_archivo'].file);
        this.formData.fotografia = fotografia_archivo;
        let fotografia_izquierda_archivo = await this.getBase64(this.formData.documentos['fotografia_izquierda_archivo'].file);
        this.formData.fotografia_izquierda = fotografia_izquierda_archivo;
        let fotografia_derecha_archivo = await this.getBase64(this.formData.documentos['fotografia_derecha_archivo'].file);
        this.formData.fotografia_derecha= fotografia_derecha_archivo;
        if (this.formData.documentos['memoria_calculo_estructural_archivo'].file) {
          this.formData.espectacular = 1;
          let memoria_calculo_estructural_archivo = await this.getBase64(this.formData.documentos['memoria_calculo_estructural_archivo'].file);
          this.formData.memoria_calculo_estructural = memoria_calculo_estructural_archivo;
        }
        if (this.formData.documentos['documento_propiedad_archivo'].file) {
          let documento_propiedad_archivo = await this.getBase64(this.formData.documentos['documento_propiedad_archivo'].file);
          this.formData.documento_propiedad = documento_propiedad_archivo;
        }
        if (this.formData.documentos['contrato_arrendamiento_archivo'].file) {
          let contrato_arrendamiento_archivo = await this.getBase64(this.formData.documentos['contrato_arrendamiento_archivo'].file);
          this.formData.contrato_arrendamiento = contrato_arrendamiento_archivo;
        }
        if (this.formData.documentos['responsiva_terceros_archivo'].file) {
          this.formData.espectacular = 1;
          let responsiva_terceros_archivo = await this.getBase64(this.formData.documentos['responsiva_terceros_archivo'].file);
          this.formData.responsiva_terceros = responsiva_terceros_archivo;
        }
        if (this.formData.documentos['anterior_permiso_archivo'].file) {
          let anterior_permiso_archivo = await this.getBase64(this.formData.documentos['anterior_permiso_archivo'].file);
          this.formData.anterior_permiso_anuncio = anterior_permiso_archivo;
        }
        await AnuncioService.create(this.formData)
        .then((response) => {
            if (response.data.success) {
              this.reset();
              //@ts-ignore
              this.fileInputValue = null;
              this.fileInputValueIzquierda = null;
              this.fileInputValueDerecha = null;
              this.$toast.success('Anuncio registrado exitosamente');
              this.$emit('formSubmitted', response.data);
            } else {
              this.$toast.error(response.data.message);
            }
            
          })
          .catch((error) => {
            this.disabled = false;
            ////this.$toast.error(error.response.data.message);
          });
      },
      async handleFormUpdateSubmit() {

        //this.disabled = false;
        Object.keys(this.formData).forEach((key) => {
          const value = this.formData[key];
        });
        this.formData.locacion_id = this.idEstablecimiento;
        if(this.formData.otro_domicilio){
          EventBus.$emit("update-direccion");
        }
        this.formData.arreglo_anuncios = this.arrayAnuncios;
        if (this.formData.documentos['fotografia_archivo'].file) {
          let fotografia_archivo = await this.getBase64(this.formData.documentos['fotografia_archivo'].file);
          this.formData.fotografia = fotografia_archivo;
        }else{
          this.formData.fotografia = null;
        }
        if (this.formData.documentos['fotografia_izquierda_archivo'].file) {
          let fotografia_izquierda_archivo = await this.getBase64(this.formData.documentos['fotografia_izquierda_archivo'].file);
          this.formData.fotografia_izquierda = fotografia_izquierda_archivo;
        }else{
          this.formData.fotografia_izquierda = null;
        }
        if (this.formData.documentos['fotografia_derecha_archivo'].file) {
          let fotografia_derecha_archivo = await this.getBase64(this.formData.documentos['fotografia_derecha_archivo'].file);
          this.formData.fotografia_derecha= fotografia_derecha_archivo;
        }else{
          this.formData.fotografia_derecha = null;
        }
        if (this.formData.documentos['memoria_calculo_estructural_archivo'].file) {
          this.formData.espectacular = 1;
          let memoria_calculo_estructural_archivo = await this.getBase64(this.formData.documentos['memoria_calculo_estructural_archivo'].file);
          this.formData.memoria_calculo_estructural = memoria_calculo_estructural_archivo;
        }else{
          this.formData.memoria_calculo_estructural = null;
        }
        if (this.formData.documentos['documento_propiedad_archivo'].file) {
          let documento_propiedad_archivo = await this.getBase64(this.formData.documentos['documento_propiedad_archivo'].file);
          this.formData.documento_propiedad = documento_propiedad_archivo;
        }else{
          this.formData.documento_propiedad = null;
        }
        if (this.formData.documentos['contrato_arrendamiento_archivo'].file) {
          let contrato_arrendamiento_archivo = await this.getBase64(this.formData.documentos['contrato_arrendamiento_archivo'].file);
          this.formData.contrato_arrendamiento = contrato_arrendamiento_archivo;
        }else{
          this.formData.contrato_arrendamiento = null;
        }
        if (this.formData.documentos['responsiva_terceros_archivo'].file) {
          this.formData.espectacular = 1;
          let responsiva_terceros_archivo = await this.getBase64(this.formData.documentos['responsiva_terceros_archivo'].file);
          this.formData.responsiva_terceros = responsiva_terceros_archivo;
        }else{
          this.formData.responsiva_terceros = null;
        }
        if (this.formData.documentos['anterior_permiso_archivo'].file) {
          let anterior_permiso_archivo = await this.getBase64(this.formData.documentos['anterior_permiso_archivo'].file);
          this.formData.anterior_permiso_anuncio = anterior_permiso_archivo;
        }else{
          this.formData.anterior_permiso_anuncio = null;
        }
        AnuncioService.update(this.formData.id,this.formData).then((response) => {
          if (response.data.success) {
            this.$toast.success('Anuncio registrado exitosamente');
            this.$emit('formSubmitted', response.data);
          }else{
            this.$toast.error(response.data.message);
          }
          this.fileInputRenovacion = null;
        }).catch((error) => {
          this.disabled = false;
        });
      },
      async getData() {
        await MaterialService.getAll().then((response) => {
          this.materiales = response.data;
        });

        await TipoAnuncioService.getAll()
          .then((response) => {
            this.tiposAnuncios = response.data;
          })
      },
      deleteModal(){
        //this.$emit('delete', this.$attrs.index);
        if (this.object.id != null) {
          AnuncioService.delete(this.object.id).then((response) => {
            if (response.data.success) {
              this.$emit('delete', this.$attrs.index);
              this.$toast.success('Anuncio eliminado exitosamente');
            }else{
              this.$toast.error(response.data.message);
            }
            
          }).catch((error) => {
            this.disabled = false;
          });
        }else{
          this.$emit('delete', this.$attrs.index);
        }
        
      },
      changeFile(type: any) {
        switch (type) {
          case 'fotografia':
            this.showFotografia = true;
            break;
          case 'memoria':
            this.showMemoria = true;
            break;
          case 'responsiva':
            this.showResponsiva = true;
            break;
        }
      },
      updateMesField() {
        const currentMonth = new Date().getMonth() + 1;
        let isTipoAnuncioValid = false;
        //recorrer el arreglo de anuncios para ver si hay algun tipo 1
        this.arrayAnuncios.forEach((anuncio: any) => {
          if(anuncio.tipo_anuncio_id == 1){
            isTipoAnuncioValid = true;
          }
        })
        //const isTipoAnuncioValid = this.formData.tipo_anuncio_id === 1;
        const isRenovacionChecked = this.formData.renovacion;

        if (isTipoAnuncioValid && isRenovacionChecked && currentMonth === 11) {
          this.formData.mes = 12;
          this.isMesDisabled = true;
        } else {
          this.formData.mes = 0;
          this.isMesDisabled = this.disabled;
        }
      }
    },
    components: {Direccion, CustomFileInputAnuncio, CustomFile, VInput },
     computed: {
      esDiciembre(): boolean {
        const mesActual = new Date().getMonth() + 1;
        return mesActual === 12;
      },
      formDir(): VForm {
        return this.$refs.formDireccion as VForm;
      },
    },
    mounted() {
      this.formData.propiedad = Number(this.propiedadProp);
      this.propiedadLocal = Number(this.propiedadProp);//pasar a integer;
      this.formData.documento_propiedad_archivo = this.documentoPropiedadProp;
      this.formData.contrato_arrendamiento_archivo = this.contratoArrendamientoProp;
      //console.log("watch",this.formData);
      this.formData.documentos = [];
      this.formData.documentos['fotografia_archivo'] = {
        code: 'fotografia_archivo',
        file: '',
        binary: '',
        data: this.formData.fotografia_archivo
      };
      this.formData.documentos['fotografia_izquierda_archivo'] = {
        code: 'fotografia_izquierda',
        file: '',
        binary: '',
        data: this.formData.fotografia_izquierda_archivo
      };
      this.formData.documentos['fotografia_derecha_archivo'] = {
        code: 'fotografia_derecha',
        file: '',
        binary: '',
        data: this.formData.fotografia_derecha_archivo
      };
      this.formData.documentos['memoria_calculo_estructural_archivo'] = {
        code: 'memoria_calculo',
        file: '',
        binary: '',
        data: this.formData.memoria_calculo_estructural_archivo
      };
      this.formData.documentos['documento_propiedad_archivo'] = {
        code: 'documento_propiedad',
        file: '',
        binary: '',
        data: this.formData.documento_propiedad_archivo
      };
      this.formData.documentos['contrato_arrendamiento_archivo'] = {
        code: 'contrato_arrendamiento',
        file: '',
        binary: '',
        data: this.formData.contrato_arrendamiento_archivo
      };
      this.formData.documentos['responsiva_terceros_archivo'] = {
        code: 'responsiva_terceros',
        file: '',
        binary: '',
        data: this.formData.responsiva_terceros_archivo
      };
      this.formData.documentos['anterior_permiso_archivo'] = {
        code: 'anterior_permiso',
        file: '',
        binary: '',
        data: this.formData.anterior_permiso_archivo
      };

      this.renovacionInterna = this.formData.renovacion;
      
      this.arrayAnuncios = this.object.anuncio_detalle;

      this.arrayAnuncios.forEach((anuncio: any) => {
        if (anuncio.is_mecanismo_electrico == 1) {
          anuncio.movimiento_rotatorio = true;
        }
        if (anuncio.is_accion_viento == 1) {
          anuncio.movimiento_rotatorio = false;
        }
      })
      this.getData();
      if (this.object.anuncio_detalle.length == 0) {
        this.arrayAnuncios.push(new AnuncioDetalle());
      } 
      this.validacionRiesgo();
      
    }
  }
);
